import Widget from "../Widget";
import { Link } from "react-router-dom/cjs/react-router-dom";

import Classes from "./index.module.css";

export default function IconBox({icon,text, ke ,to, width}){
    return(
        <Link className={Classes.iconBox} key={ke} to={to} style={{width:`${width}%`}}>
            <div className={Classes.widget} >
                {icon}
                <br/>
                <span>{text}</span>
            </div>
        </Link>
    )
}